const EMPTY_QUILL_HTML = "<p><br></p>";

/** Убирает лишние обрамляющие кавычки, если бэк вернул JSON-строку как текст. */
export const parseDescriptionFromApi = (value) => {
    if (value == null) {
        return "";
    }
    if (typeof value !== "string") {
        return String(value);
    }

    let s = value.trim();
    for (let i = 0; i < 3; i++) {
        const wrappedInDouble = s.length >= 2 && s.startsWith('"') && s.endsWith('"');
        const wrappedInSingle = s.length >= 2 && s.startsWith("'") && s.endsWith("'");
        if (!wrappedInDouble && !wrappedInSingle) {
            break;
        }
        try {
            const parsed = JSON.parse(s);
            if (typeof parsed === "string") {
                s = parsed;
                continue;
            }
        } catch {
            // not valid JSON — strip outer quotes manually
        }
        s = s.slice(1, -1);
    }
    return s;
};

const isEmptyRichTextValue = (html) => {
    if (!html || html === EMPTY_QUILL_HTML) {
        return true;
    }
    const text = html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
    return text === "";
};

export const isEmptyRichText = (html) => isEmptyRichTextValue(parseDescriptionFromApi(html));

export const normalizeRichText = (html) => {
    const parsed = parseDescriptionFromApi(html);
    return isEmptyRichTextValue(parsed) ? "" : parsed;
};

export const isRichTextEqual = (a, b) => normalizeRichText(a) === normalizeRichText(b);
